import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDQU1W8Lbww7as60hZrnKX8wxUzTSljqQI",
  authDomain: "vdoc-f55a8.firebaseapp.com",
  projectId: "vdoc-f55a8",
  storageBucket: "vdoc-f55a8.firebasestorage.app",
  messagingSenderId: "243887787927",
  appId: "1:243887787927:web:3706c4569e1a02db233ed2",
  measurementId: "G-LP3120NL1W",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };
